import { HttpContextToken } from '@angular/common/http';

// Only requests explicitly made by the TalentNova integration bypass app auth.
export const TALENT_NOVA_REQUEST = new HttpContextToken<boolean>(() => false);
